/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { actionTypes } from '../../../common/SummaryCard/CardContext';
import SummaryCard from '../../../common/SummaryCard/SummaryCard';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function FeesCard({ feeEntries, isSummary, readOnly = false, cardTitle, icon }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      configurableIcon={icon ?? 'euro'}
      cardTitle={cardTitle ?? t('fees.title')}
      cardsubTitle=""
      entries={feeEntries}
      actionType={!isSummary && feeEntries.length ? actionTypes.SUMMARY : null}
      sectionName="submission_fees"
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
    />
  );
}
